/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Placement Test View Model
    // Holds a placement test data
    /**************************************/
    function PlacementTestViewModel() {

        var self = this;

        /***  PROPERTIES ***/
        this.SectionRequired = ko.observable(false);
        this.DataList = ko.observableArray([]);
        this.DataSectionTracker = ko.observableArray();

        this.ACTWorkingItem = ko.observable(null);
        this.SATWorkingItem = ko.observable(null);
        this.GMATWorkingItem = ko.observable(null);
        this.GREWorkingItem = ko.observable(null);
        this.TOEFLWorkingItem = ko.observable(null);
        this.PRAXISWorkingItem = ko.observable(null);
        this.PRAXISIIWorkingItem = ko.observable(null);
        this.TestScoreIndexCounter = 0;

        /***  PROPERTIES ***/

        this.Completed = ko.observable(false);
        this.StoredTestViewModels = ko.observableArray();

        this.SaveItem = function (data, event) {
            // save to database               
            if (data.Mode() == 'EDIT') {
                // get a copy of the viewModel
                var orignalTestViewModel = self.TestViewModelByIndex(data.Index());
                if (orignalTestViewModel.length == 0) {
                    return;
                } else {
                    orignalTestViewModel = orignalTestViewModel[0];
                }

                self.StoredTestViewModels.remove(orignalTestViewModel);

                var newTestViewModel = orignalTestViewModel.Copy(data);
                self.StoredTestViewModels.push(newTestViewModel);

            } else {
                // new record
                var newTestViewModel = data.Clone();
                newTestViewModel.Index(self.StoredTestViewModels().length);

                self.StoredTestViewModels.push(newTestViewModel);
            }

            self.Completed(true);
            data.Clear();

            // show the display form
            jQuery('.dataDisplayView').show();

            // hide the input form
            jQuery('.dataEntryView').hide();

            self.ACTWorkingItem(null);
            self.SATWorkingItem(null);
            self.GMATWorkingItem(null);
            self.GREWorkingItem(null);
            self.TOEFLWorkingItem(null);
            self.PRAXISWorkingItem(null);
            self.PRAXISIIWorkingItem(null);

            sm.portal.ui.readyPage();

        };

        this.EditItem = function (data, event) {
            // hide the display form
            jQuery('.dataDisplayView').hide();

            // show the input form
            jQuery('.dataEntryView').show();

            var selectedTestScore = self.TestViewModelByIndex(data.Index());
            if (selectedTestScore.length === 0) {
                return;
            } else {
                selectedTestScore = selectedTestScore[0];
            }

            if (selectedTestScore.AnythingPopulated()) {
                switch (data.PlacementTestType()) {
                    case "SAT":
                        selectedTestScore.Mode('EDIT');
                        self.SATWorkingItem(selectedTestScore.Clone());
                        break;

                    case "ACT":
                        selectedTestScore.Mode('EDIT');
                        self.ACTWorkingItem(selectedTestScore.Clone());
                        sm.portal.page.application.additionalFieldsToggle();
                        break;

                    case "GMAT":
                        selectedTestScore.Mode('EDIT');
                        self.GMATWorkingItem(selectedTestScore.Clone());
                        break;

                    case "GRE":
                        selectedTestScore.Mode('EDIT');
                        self.GREWorkingItem(selectedTestScore.Clone());
                        break;

                    case "PRAXIS":
                        selectedTestScore.Mode('EDIT');
                        self.PRAXISWorkingItem(selectedTestScore.Clone());
                        break;

                    case "PRAXISSII":
                        selectedTestScore.Mode('EDIT');
                        self.PRAXISIIWorkingItem(selectedTestScore.Clone());
                        break;

                    case "TOEFL":
                        selectedTestScore.Mode('EDIT');
                        self.TOEFLWorkingItem(selectedTestScore.Clone());
                        break;
                }
            }
        };

        this.RemoveItem = function (data, event) {
            self.StoredTestViewModels.remove(function (item) { return item.PlacementTestType == data.PlacementTestType && item.TestDate == data.TestDate });
            if (self.StoredTestViewModels().length == 0) {
                self.Completed(false);
            }
        };

        this.CancelItem = function (data, event) {

            //// show all display views
            jQuery('.dataDisplayView').show();

            self.ACTWorkingItem(null);
            self.SATWorkingItem(null);
            self.GMATWorkingItem(null);
            self.GREWorkingItem(null);
            self.TOEFLWorkingItem(null);
            self.PRAXISWorkingItem(null);
            self.PRAXISIIWorkingItem(null);

            sm.portal.ui.readyPage();
        };


        this.AddACT = function () {
            jQuery('.dataDisplayView').hide();
            this.ACTWorkingItem(new sm.portal.vm.placementTest.ACTViewModel({ index: self.TestScoreIndexCounter++ }));
            sm.portal.page.application.additionalFieldsToggle();
        };
        this.AddSAT = function () {
            jQuery('.dataDisplayView').hide();
            this.SATWorkingItem(new sm.portal.vm.placementTest.SATViewModel({ index: self.TestScoreIndexCounter++ }));
        };
        this.AddGMAT = function () {
            jQuery('.dataDisplayView').hide();
            this.GMATWorkingItem(new sm.portal.vm.placementTest.GMATViewModel({ index: self.TestScoreIndexCounter++ }));
        };
        this.AddGRE = function () {
            jQuery('.dataDisplayView').hide();
            this.GREWorkingItem(new sm.portal.vm.placementTest.GREViewModel({ index: self.TestScoreIndexCounter++ }));
        };
        this.AddTOEFL = function () {
            jQuery('.dataDisplayView').hide();
            this.TOEFLWorkingItem(new sm.portal.vm.placementTest.TOEFLViewModel({ index: self.TestScoreIndexCounter++ }));
        };
        this.AddPRAXIS = function () {
            jQuery('.dataDisplayView').hide();
            this.PRAXISWorkingItem(new sm.portal.vm.placementTest.PRAXISViewModel({ index: self.TestScoreIndexCounter++ }));
        };
        this.AddPRAXISII = function () {
            jQuery('.dataDisplayView').hide();
            this.PRAXISIIWorkingItem(new sm.portal.vm.placementTest.PRAXISIIViewModel({ index: self.TestScoreIndexCounter++ }));
        };

        this.RemoveAllTests = function () {

            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.ACTWorkingItem() == null)) {
                self.ACTWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.SATWorkingItem() == null)) {
                self.SATWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.GMATWorkingItem() == null)) {
                self.GMATWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.GREWorkingItem() == null)) {
                self.GREWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.TOEFLWorkingItem() == null)) {
                self.TOEFLWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.PRAXISWorkingItem() == null)) {
                self.PRAXISWorkingItem(null);
            }
            if (jQuery('.dataDisplayView').is(':visible') || (!jQuery('.dataDisplayView').is(':visible') && self.PRAXISIIWorkingItem() == null)) {
                self.PRAXISIIWorkingItem(null);
            }
        };

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("TestScoreContainer");
        this.Touched = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.ExtractATO = function () {

            var SATTestList = Array();
            var ACTTestList = Array();
            var TOEFLTestList = Array();
            var PRAXISTestList = Array();
            var PRAXISIITestList = Array();
            var GRETestList = Array();
            var GMATTestList = Array();

            for (var i = 0; i < self.StoredTestViewModels().length; i++) {

                if (self.StoredTestViewModels()[i].AnythingPopulated()) {

                    var test = self.StoredTestViewModels()[i];

                    switch (test.PlacementTestType()) {

                        case "SAT":
                            SATTestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "ACT":
                            ACTTestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "TOEFL":
                            TOEFLTestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "PRAXIS":
                            PRAXISTestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "PRAXISII":
                            PRAXISIITestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "GRE":
                            GRETestList.push(ko.toJS(test.ExtractATO()));
                            break;
                        case "GMAT":
                            GMATTestList.push(ko.toJS(test.ExtractATO()));
                            break;
                    }
                }
            }

            var testScoreData = {
                SAT: SATTestList,
                ACT: ACTTestList,
                TOEFL: TOEFLTestList,
                PRAXIS: PRAXISTestList,
                PRAXISII: PRAXISIITestList,
                GREGeneral: GRETestList,
                GMAT: GMATTestList
            };

            return testScoreData;

        };
        /*** SECTION PROPERTIES ***/

        /*** SECTION DRIVING SUBSCRIPTION PROPERTIES ***/
        this.DataList.subscribe(function (newValue) {
            self.UpdateSectionsByTests(newValue);
        }, this);

        this.UpdateSectionsByTests = function (value) {
            var sectionsToAdd = Array();
            var sectionsToRemove = Array();

            if (value != null && value.length > 0) {
                sectionsToAdd.push({ section: 'TestScore', required: this.SectionRequired() });
            }
            else {
                sectionsToRemove.push('TestScore');
            }

            viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
        };
        /*** SECTION DRIVING SUBSCRIPTION PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.AnythingPopulated = function () {
            if (this.DataList().length > 0) {
                for (var i = 0; i < this.DataList().length; i++) {
                    var dataItem = this.DataList()[i];
                    if (dataItem.AnythingPopulated()) return true;
                }
            }
            return false;
        };
        this.CompletedOLD = ko.computed(function () {
            if (!this.SectionRequired) {
                return true;
            }
            else {
                //Loop Through each section to see if there is required sections
                if (this.DataSectionTracker().length > 0) {
                    var SectionsCompleted = 0;
                    for (var i = 0; i < this.DataSectionTracker().length; i++) {
                        var name = this.DataSectionTracker()[i].ItemName;
                        var stepName = this.DataSectionTracker()[i].Section;
                        var req = this.DataSectionTracker()[i].Required;

                        if (req != null && req == false) {
                            SectionsCompleted++;
                        }
                        else {
                            var detailItems = this.FilteredItems(name);
                            var comp = false;
                            for (var x = 0; x < detailItems.length; x++) {
                                if (detailItems[x].AnythingPopulated() && comp == false) {
                                    comp = true;
                                    SectionsCompleted++;
                                }
                            }
                        }
                    }
                    return this.DataSectionTracker().length == SectionsCompleted;
                }
            }
        }, this);

        this.LoadModel = function (container) {

            // update application section configurations
            if (container && container.Payload && container.Payload.Config) {
                viewModel.SetSectionsConfigData("TestScore", container.Payload.Config, true);
            }
            // no result for test are being returned... probably need to clear everything out.
            //self.StoredTestViewModels([]);
            //self.DataList([]);
            //self.DataSectionTracker([]);

            this.RemoveAllTests();

            if (container != null
                && container.Payload != null
                && container.Payload.TestSections != null
                && container.Payload.TestSections.length > 0) {

                for (var i = 0; i < container.Payload.TestSections.length; i++) {
                    this.TrackAndLoadSections(container.Payload.TestSections[i]);
                }
            }
            this.DataLoading(false);
            this.DataLoaded(true);

            sm.portal.ui.detailedList();

            if (smapi.constant.applicationDebugFlag) { console.log('[TestScoreVM] Data Loaded'); }

        };

        this.TrackAndLoadSections = function (test) {

            if (test != null && test.Details != null) {

                var testDetails = test.Details;
                var sections = this.DataSectionTracker();

                if (sections.length > 0) {
                    //Clear out non matching existing sections
                    for (var i = 0; i < sections.length; i++) {
                        var theListObj = sections[i];
                        var foundItem = jQuery.grep(testDetails, function (n, i) {
                            return n.AdmissionStepBusinessName == theListObj.Section;
                        });

                        if (foundItem.length == 0) {
                            //this.DataSectionTracker(jQuery.grep(this.DataSectionTracker(), function (value) {
                            //    return value.Section != foundItem[0].AdmissionStepBusinessName;
                            //}));

                            //TODO cleanup for existing data item using the type or clear DB records...
                        }
                    }
                }

                // remove newly created items
                var totalViewModelsCount = self.StoredTestViewModels().length;
                while (totalViewModelsCount--) {
                    if (self.StoredTestViewModels()[totalViewModelsCount].ID() == 0)
                        self.StoredTestViewModels.splice(totalViewModelsCount, 1);
                }

                //Add any missing items, ignoring ones that already exist
                for (var i = 0; i < testDetails.length; i++) {

                    var testDetail = testDetails[i];
                    var testViewModel = null;
                    var sectionExists = this.SectionExists(testDetail.AdmissionStepBusinessName);

                    // If any step is required, mark the section required
                    if (!sm.portal.utility.isNullOrEmpty(testDetail.Required) && testDetail.Required == true) {
                        this.SectionRequired(true);
                    }

                    // Marking which tests are being asked for, just create an Empty test view model
                    testViewModel = this.GetEmptyViewModel(testDetail.AdmissionStepBusinessName);
                    this.AddTestViewModelToDataList(testViewModel, sectionExists);

                    if (!sectionExists && testViewModel != null) {
                        this.DataSectionTracker.push({ Section: testDetail.AdmissionStepBusinessName, Required: testDetail.Required, ItemName: testViewModel.PlacementTestType() });
                    }

                    // Add in new test view models
                    if (testDetail.LineItems != null && testDetail.LineItems.length > 0) {

                        for (var j = 0; j < testDetail.LineItems.length; j++) {
                            var lineItem = testDetail.LineItems[j];
                            var newTestViewModel = this.GetAndPopulateViewModel(testDetail.AdmissionStepBusinessName, lineItem);
                            if (newTestViewModel !== null) {
                                if (newTestViewModel.ID() === 0 || !this.TestViewModelExists(newTestViewModel.ID())) {
                                    // add it to the list
                                    self.StoredTestViewModels.push(newTestViewModel);
                                }
                            }
                        }

                        self.Completed(self.StoredTestViewModels().length > 0);
                    }
                }
            }
            else {
                // no result for test are being returned... probably need to clear everything out.
                self.StoredTestViewModels([]);
                self.DataList([]);
                self.DataSectionTracker([]);
            }

        };

        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            //This will be in the next story of getting data from an exisint saved Application
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=testscore&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }

            if (!this.DataLoaded() && !this.DataLoading()) {
                this.DataLoading(true);
                this.LoadModel(null);
            }
        };

        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };

        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };

        this.ProcessOnServer = function () {
            return true;
        };

        this.FilteredStoredItems = function (type) {
            return ko.utils.arrayFilter(this.StoredTestViewModels(), function (item) {
                return item.PlacementTestType() == type;
            });
        };

        this.SortedFilteredStoredTestViewModels = function (type) {
            var list = ko.utils.arrayFilter(this.StoredTestViewModels(), function (item) {
                return item.PlacementTestType() == type;
            });

            // no sort it
            return list.sort(function (left, right) {
                return Date.parse(left.TestDate()) == Date.parse(right.TestDate()) ?
                    0 :
                    (Date.parse(left.TestDate()) < Date.parse(right.TestDate()) ? -1 : 1);
            });

        };

        this.FilteredItems = function (type) {
            return ko.utils.arrayFilter(this.DataList(), function (item) {
                if (item == null) return false;
                return item.PlacementTestType() == type;
            });
        };
        this.FilteredItemsPopulated = function (type) {
            var populated = false;
            var items = this.FilteredStoredItems(type);
            for (var i = 0; i < items.length; i++) {
                if (!populated) {
                    if (items[i].AnythingPopulated())
                        populated = true;
                }
            }
            return populated;
        };
        this.SectionsByName = function (section) {
            return ko.utils.arrayFilter(this.DataSectionTracker(), function (item) {
                return item.Section == section;
            });
        };
        this.SectionExists = function (section) {
            return this.SectionsByName(section).length > 0;
        };
        this.TestViewModelByID = function (id) {
            return ko.utils.arrayFilter(this.StoredTestViewModels(), function (item) {
                return item.ID() == id;
            });
        };

        this.TestViewModelByIndex = function (index) {
            return ko.utils.arrayFilter(this.StoredTestViewModels(), function (item) {
                return item.Index() === index;
            });
        };

        this.TestViewModelExists = function (id) {
            return this.TestViewModelByID(id).length > 0;
        };


        this.GetEmptyViewModel = function (businessMeaningName) {
            var obj = null;
            switch (businessMeaningName) {
                case "Application.ACTScore":
                    obj = new sm.portal.vm.placementTest.ACTViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.SATScore":
                    obj = new sm.portal.vm.placementTest.SATViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.TOEFL":
                    obj = new sm.portal.vm.placementTest.TOEFLViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.PraxisScore":
                    obj = new sm.portal.vm.placementTest.PRAXISViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.PraxisIIScore":
                    obj = new sm.portal.vm.placementTest.PRAXISIIViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.GMATScore":
                    obj = new sm.portal.vm.placementTest.GMATViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
                case "Application.GREScore":
                    obj = new sm.portal.vm.placementTest.GREViewModel({ index: self.TestScoreIndexCounter++ });
                    break;
            }
            return obj;
        };

        // return a view model based on businessMeaningName, populated by data
        this.GetAndPopulateViewModel = function (businessMeaningName, data) {
            var obj = null;
            switch (businessMeaningName) {
                case "ACT":
                case "Application.ACTScore":
                    obj = new sm.portal.vm.placementTest.ACTViewModel({
                        PlacementTestType: 'ACT',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        Math: data.Math,
                        English: data.English,
                        Reading: data.Reading,
                        Science: data.Science,
                        Composite: data.Composite,
                        UsageMech: data.UsageMech,
                        RhetSkills: data.RhetSkills,
                        PreAlgEleAlg: data.PreAlgEleAlg,
                        AlgCooGeo: data.AlgCooGeo,
                        PlaneGeoTrig: data.PlaneGeoTrig,
                        SocStuSci: data.SocStuSci,
                        ArtLit: data.ArtLit,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "SAT":
                case "Application.SATScore":
                    obj = new sm.portal.vm.placementTest.SATViewModel({
                        PlacementTestType: 'SAT',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        Reading: data.Reading,
                        Math: data.Math,
                        Writing: data.Writing,
                        Essay: data.Essay,
                        Composite: data.Composite,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "TOEFL":
                case "Application.TOEFL":
                    obj = new sm.portal.vm.placementTest.TOEFLViewModel({
                        PlacementTestType: 'TOEFL',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        Score: data.Score,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "Praxis":
                case "Application.PraxisScore":
                    obj = new sm.portal.vm.placementTest.PRAXISViewModel({
                        PlacementTestType: 'PRAXIS',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        ETSID: data.ETSID,
                        TestName: data.TestName,
                        Score: data.Score,
                        PassingScore: data.PassingScore,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "PraxisII":
                case "Application.PraxisIIScore":
                    obj = new sm.portal.vm.placementTest.PRAXISIIViewModel({
                        PlacementTestType: 'PRAXISII',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        ETSID: data.ETSID,
                        TestName: data.TestName,
                        Score: data.Score,
                        PassingScore: data.PassingScore,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "GMAT":
                case "Application.GMATScore":
                    obj = new sm.portal.vm.placementTest.GMATViewModel({
                        PlacementTestType: 'GMAT',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        Quantitative: data.Quantitative,
                        Verbal: data.Verbal,
                        AWA: data.AWA,
                        Total: data.Total,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;

                case "GREScore":
                case "Application.GREScore":
                    obj = new sm.portal.vm.placementTest.GREViewModel({
                        PlacementTestType: 'GRE',
                        ID: data.ID,
                        TestDate: sm.portal.utility.formatDate(data.TestDate, true),
                        Verbal: data.Verbal,
                        Quantitative: data.Quantitative,
                        AnalyticalWriting: data.AnalyticalWriting,
                        Index: self.TestScoreIndexCounter++
                    });
                    break;
            }   // End Switch
            return obj;
        };

        //Add view model 
        this.AddTestViewModelToDataList = function (testViewModel, sectionExists) {

            if (!sectionExists && testViewModel) {
                this.DataList.push(testViewModel);
            } else {

                var foundIt = false;
                for (var i = 0; i < this.DataList().length; i++) {
                    if (this.DataList()[i] != null && testViewModel) {
                        if (this.DataList()[i].PlacementTestType() == testViewModel.PlacementTestType()) {
                            this.DataList()[i] = testViewModel;
                            foundIt = true;
                            break;
                        }
                    }
                }
                // If we didn't find a match, add it to the list.
                if (!foundIt) {
                    this.DataList.push(testViewModel);
                }

            }

        };
        /*** SECTION METHODS ***/


        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        PlacementTestViewModel: PlacementTestViewModel,
    });

})(jQuery);
